import { ReactNode } from 'react'

import { IconButton } from '@/components/base/icon-button'
import { Tooltip } from '@/components/base/tooltip'

export function LockedIconButton({ label, children }: { label: string; children: ReactNode }) {
	return (
		<Tooltip content={label}>
			<span className='inline-flex'>
				<IconButton disabled className='pointer-events-none shrink-0'>
					{children}
				</IconButton>
			</span>
		</Tooltip>
	)
}

// Tooltip text when a resource is externally managed, else undefined.
export const managedExternallyLabel = <S extends string>(
	source: S | null | undefined,
	sourceName: (source: S) => string,
	message: (args: { source: string }) => string
): string | undefined => (source ? message({ source: sourceName(source) }) : undefined)
